
namespace RioERP.Orders {
    export class FranchiseeOrdersColumns {
        static columnsKey = 'Orders.FranchiseeOrders';
    }
}